import React from 'react'
import { connect } from 'react-redux'
import { DrawControl } from '@leverege/ui-mapbox-elements'
import * as turf from '@turf/turf'
import DrawModes from './drawModes'

class LDrawControl extends DrawControl {
  constructor( props ) {
    super( props )
    const lngLat = props.lngLat.length === 4 ? [ ...props.lngLat, props.lngLat[0] ] : props.lngLat
    this.state = {
      selected : null,
      lngLat }
  }

  getSnapshotBeforeUpdate( prevProps, prevState ) {
    const { lngLat, selected } = this.state
    const { mode } = this.props
    if ( lngLat.length ) {
      if ( lngLat !== prevState.lnLat ) {
        const image = this.context.getSource( prevProps.sourceId )
        if ( image ) {
          image.setCoordinates( lngLat )
        }
      }
    }
    const curSelection = this.draw.getSelected()?.features?.[0]?.id
    if ( mode !== prevProps.mode || selected && !curSelection ) {
      this.draw.changeMode( mode )
    }
    return null
  }

  onTrash = () => {
    this.draw.deleteAll()
    this.setState( { lngLat : [] } )
  }
}

class ConnectedDrawControl extends React.Component {
  constructor( props ) {
    super( props )
  }
  
  onKeyDown = ( evt ) => {
    // SUPER HACK- add the listeners to te actual geo tile view
    if ( evt?.target?.className !== 'mapboxgl-canvas' ) {
      return 
    }

    const { onDrawUpdate, drawControlRef, mapSource, getImage } = this.props
    const map = mapSource.map
    const f = this.getFeature()
    
    if ( f ) {
      const value = {
        L : 0.5,
        l : 5,
        K : -0.5,
        k : -5,
        i : 1.1,
        I : 1.01,
        o : 1 / 1.1,
        O : 1 / 1.01,
        w : 0.05,
        W : 0.01,
        s : 0.05,
        S : 0.01,
        a : 0.05,
        A : 0.01,
        d : 0.05,
        D : 0.01,
      }
      if ( [ 'l', 'k', 'L', 'K' ].includes( evt.key ) ) {
        var poly = turf.transformRotate( f, value[evt.key] )
        console.log( 'poly=', poly )
        onDrawUpdate( poly, {} )
      }
      if ( [ 'i', 'I', 'o', 'O' ].includes( evt.key ) ) {
        var poly = turf.transformScale( f, value[evt.key] )
        console.log( 'poly=', poly )
        onDrawUpdate( poly, {} )
      }
      if ( [ 'w', 'W', 's', 'S', 'a', 'A', 'd', 'D' ].includes( evt.key ) ) {
        const dir = { w : 0, W : 0, s : 180, S : 180, a : 270, A : 270, d : 90, D : 90 }
        const bnd = map.getBounds()
        const cln = bnd.getCenter().lng
        const clt = bnd.getCenter().lat
        const c = turf.point( [ cln, clt ] )
        const dn = turf.rhumbDistance( c, turf.point( [ cln, bnd.getNorth() ] ), { } )

        var poly = turf.transformTranslate( f, dn * value[evt.key], dir[evt.key], {} )
        onDrawUpdate( poly, {} )
      }
      if ( map && evt.key === 'c' ) {
        try {
          // const p = turf.polygon( [ drawControl.state.lngLat ] )
          const center = turf.center( f )
          const { lng, lat } = map.getCenter()
          const mCenter = turf.point( [ lng, lat ] )
          const d = turf.rhumbDistance( center, mCenter, { } )
          const b = turf.rhumbBearing( center, mCenter, { } )
          const poly = turf.transformTranslate( f, d, b, {} )
          onDrawUpdate( poly, {} )
        } catch ( x ) {
          console.log( x )
        }
      }
    }
    if ( map && evt.key === 'C' ) {
      try {
        const img = getImage()
        console.log( 'img=', img )
        if ( typeof img.width !== 'number' || typeof img.height !== 'number' ) {
          return
        }
        const bnd = map.getBounds()
        const dh = bnd.getNorth() - bnd.getSouth()
        const dw = dh * ( img.width / img.height )
        const cln = bnd.getCenter().lng
        const clt = bnd.getCenter().lat
        const c = turf.point( [ cln, clt ] )
        const dn = turf.rhumbDistance( c, turf.point( [ cln, bnd.getNorth() ] ), { } )
        const de = dn * ( img.width / img.height )
        const n = turf.rhumbDestination( c, dn * 0.25, 0, {} ).geometry.coordinates[1]
        const s = turf.rhumbDestination( c, dn * 0.25, 180, {} ).geometry.coordinates[1]
        const e = turf.rhumbDestination( c, de * 0.25, 90, {} ).geometry.coordinates[0]
        const w = turf.rhumbDestination( c, de * 0.25, 270, {} ).geometry.coordinates[0]

        const p = turf.polygon( [ [ [ w, n ], [ e, n ], [ e, s ], [ w, s ], [ w, n ] ] ] )
        const center = turf.center( p )
        const { lng, lat } = map.getCenter()
        const mCenter = turf.point( [ lng, lat ] )
        const d = turf.rhumbDistance( center, mCenter, { } )
        const b = turf.rhumbBearing( center, mCenter, { } )
        const poly = turf.transformTranslate( p, d, b, {} )
        onDrawUpdate( poly, {} )
      } catch ( x ) {
        console.log( x )
      }
    }
  
  }

  componentDidMount() {
    this.setFeature()
    window.addEventListener( 'keydown', this.onKeyDown )
  }

  componentWillUnMount() {
    window.removeEventListener( 'keydown', this.onKeyDown )
  }

  componentDidUpdate( prevProps ) {
    const { currentFeature } = this.props
    if ( currentFeature !== prevProps.currentFeature ) {
      this.setFeature()
    }
  }

  getFeature = () => this.props.currentFeature

  setFeature = () => {
    if ( !this.props.drawControlRef?.current?.draw ) {
      // give draw control some time to setup
      setTimeout( this.setFeature, 1500 )
    } else {
      const { currentFeature, drawControlRef } = this.props
      if ( currentFeature ) {
        drawControlRef.current.draw.set( { type : 'FeatureCollection', features : [ currentFeature ] } )
      }
    }
  }

  onTrash = ( cleanup, cb ) => {
    const { drawControlRef } = this.props
    const drawControl = this.drawControlRef.current
    if ( drawControl ) {
      drawControl.draw.deleteAll()
      drawControl.setState( { lngLat : [] } )
    }
  }

  render() {
    const { currentFeature = {}, drawControlRef, mode, onDrawUpdate, getFeature, mapSource, getImage, ...rest } = this.props
    const lngLat = currentFeature?.geometry?.coordinates?.[0] || []
    return (
      <LDrawControl
        ref={drawControlRef}
        lngLat={lngLat}
        onDrawUpdate={onDrawUpdate}
        modes={DrawModes.init( {
          onDrawUpdate,
          getFeature : this.getFeature
        } )}
        mode={mode}
        {...rest} />
    )
  }
}

export default connect( state => ( {
  mode : state.geotile?.editor?.drawMode,
  currentFeature : state.geotile?.editor?.currentFeature,
} ) )( ConnectedDrawControl )
